import React, { useState } from 'react';
import styled from 'styled-components';

const FilterContainer = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
`;

const FilterTitle = styled.h3`
  margin: 0 0 15px 0;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  &:hover {
    color: #667eea;
  }
`;

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
`;

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  
  label {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
  }
  
  input {
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #667eea;
    }
  }
`;

const FilterButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 15px;
  
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    transition: all 0.2s;
  }
`;

const ApplyButton = styled.button`
  background-color: #667eea;
  color: white;
  
  &:hover {
    background-color: #5568d3;
  }
`;

const ClearButton = styled.button`
  background-color: #f0f0f0;
  color: #333;
  
  &:hover {
    background-color: #e0e0e0;
  }
`;

const AdvancedFilters = ({ onApplyFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [filters, setFilters] = useState({
    priceMin: '',
    priceMax: '',
    dateFrom: '',
    dateTo: '',
  });

  const handleChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  const handleApply = () => {
    onApplyFilters(filters);
  };

  const handleClear = () => {
    setFilters({
      priceMin: '',
      priceMax: '',
      dateFrom: '',
      dateTo: '',
    });
    onApplyFilters({});
  };

  return (
    <FilterContainer>
      <FilterTitle onClick={() => setIsExpanded(!isExpanded)}>
        🔍 Filtros Avanzados
        <span>{isExpanded ? '▲' : '▼'}</span>
      </FilterTitle>
      
      {isExpanded && (
        <>
          <FilterGrid>
            <FilterGroup>
              <label>Precio Mínimo (IDR)</label>
              <input
                type="number"
                value={filters.priceMin}
                onChange={(e) => handleChange('priceMin', e.target.value)}
                placeholder="Ej: 100000"
                min="0"
              />
            </FilterGroup>
            
            <FilterGroup>
              <label>Precio Máximo (IDR)</label>
              <input
                type="number"
                value={filters.priceMax}
                onChange={(e) => handleChange('priceMax', e.target.value)}
                placeholder="Ej: 5000000"
                min="0"
              />
            </FilterGroup>
            
            <FilterGroup>
              <label>Fecha Desde</label>
              <input
                type="date"
                value={filters.dateFrom}
                onChange={(e) => handleChange('dateFrom', e.target.value)}
              />
            </FilterGroup>
            
            <FilterGroup>
              <label>Fecha Hasta</label>
              <input
                type="date"
                value={filters.dateTo}
                onChange={(e) => handleChange('dateTo', e.target.value)}
              />
            </FilterGroup>
          </FilterGrid>
          
          <FilterButtons>
            <ApplyButton onClick={handleApply}>
              Aplicar Filtros
            </ApplyButton>
            <ClearButton onClick={handleClear}>
              Limpiar Filtros
            </ClearButton>
          </FilterButtons>
        </>
      )}
    </FilterContainer>
  );
};

export default AdvancedFilters;
